'use strict';
// write your code here
var populationOfCounties = document.querySelectorAll('span.population');
var totalPopulation = 0;
var averagePopulation = 0;
var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
try {
    for(var _iterator = populationOfCounties[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
        var element = _step.value;
        var population = element.textContent;
        var cleared = population.replace(/[^\d]/g, '').trim();
        totalPopulation += +cleared;
    }
} catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
} finally{
    try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
        }
    } finally{
        if (_didIteratorError) {
            throw _iteratorError;
        }
    }
}
averagePopulation = totalPopulation / populationOfCounties.length;
var totalPopulationElement = document.querySelector('span.total-population');
var avgPopulationElement = document.querySelector('span.average-population');
totalPopulationElement.textContent = totalPopulation.toLocaleString('en-US');
avgPopulationElement.textContent = Math.round(averagePopulation).toLocaleString('en-US');

//# sourceMappingURL=js_get_data_DOM.271b8997.js.map
